/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the My Account page
    // attach the orders row expand event handler
    // if ($('.orders__table__data__expand').length) {
    //   $('.orders__table__data__expand').on('click',e => {
    //     e.preventDefault();
    //
    //     // grabs our DOM elements
    //     // const target = e.target || e.srcElement;
    //     // const $icon = $(target).find('i');
    //     // const $row = $(target).closest('.order-details');
    //     // const $orderDetailsRow = $row.next('.order-details-items');
    //     //
    //     // // check if the order detail row already has an
    //     // // active class and adjust the height accordingly
    //     // let orderDetailsRowHeight = $orderDetailsRow.attr('data-active-height');
    //     // if ($orderDetailsRow.hasClass('active')) {
    //     //   orderDetailsRowHeight = 0;
    //     //   $orderDetailsRow.toggleClass('active');
    //     //   $orderDetailsRow.css({"height":`${orderDetailsRowHeight}px`,"padding":"0px 15px"});
    //     // } else {
    //     //   orderDetailsRowHeight = $orderDetailsRow.attr('data-active-height');
    //     //   $orderDetailsRow.css({"height":`${orderDetailsRowHeight}px`, "padding":"5px 15px"});
    //     //   $orderDetailsRow.toggleClass('active');
    //     // }
    //     //
    //     // console.log('$orderDetailsRow', orderDetailsRowHeight);
    //     //
    //     // // toggle classes
    //     // $icon.toggleClass('active');
    //     // $row.toggleClass('active');
    //   });
    // }

    // attach the card edit/card flip event
    if ($('.my-account__account-details__edit-btn').length) {
      $('.my-account__account-details__edit-btn, .my-account__account-details__close-btn').on('click',e => {
        e.preventDefault();
        const target = e.target || e.srcElement;
        $(target).closest('.my-account__account-details__user, .my-account__account-details__pro').toggleClass('flipped');
      });
    }

    // add handler for clicking the modal delete button
    $('#modal-delete-professional').on('click', e => {
      e.preventDefault();
      // perform delete of professional information
      const jsonObj = {'proCode': ''};
      const $promise = $.ajax({
        url: my_account.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': jsonObj, 'security': my_account.nonce, 'action': 'myAccountSaveProCode'}
      });
      // close modal
      $('#remove-professional-modal').modal('hide');
      // reset the card to have the Add Professional button
      $('.my-account__account-details__pro-details').remove();
      const replacement = '<div class="my-account__account-details__epionce-near-you-btn-container">'+
                          '<a id="add-a-pro-btn" href="#" class="my-account__account-details__epionce-near-you-btn">Add a Professional</a>'+
                        '</div>';
      $('.my-account__account-details__pro__card__front > .my-account__account-details__title-row').after(replacement);
      // delete pro code from input field on card reverse
      $('#your-pro-code').val('');
    });

    // add handler for clicking modal Go Back button
    $('#modal-dont-delete-professional').on('click', e => {
      e.preventDefault();
      $('#remove-professional-modal').modal('hide');
    });

    // add change handler to the address edit card address type radio buttons
    if ($('#billing-address-toggle').length) {
      $('#billing-state').val($('#billing-state').attr('data-option-value'));
      $('#shipping-state').val($('#shipping-state').attr('data-option-value'));
      const addressType = ["billing","shipping"];
      $('[data-address-type="shipping"]').css({"display":"none"});

      $('[name="address"]').on('change',e => {
        const target = e.target || e.srcElement;
        const addressType = $(target).attr('data-address-type-filter');
        if (addressType === 'billing') {
          $(`[data-address-type="${addressType}"]`).css({"display":"block"});
          $('[data-address-type="shipping"]').css({"display":"none"});
        } else {
          $(`[data-address-type="${addressType}"]`).css({"display":"block"});
          $('[data-address-type="billing"]').css({"display":"none"});
        }
      });
    }

    // add click handler for the user/address info card save button
    if ($('#save-customer-info-btn').length) {
      $('#save-customer-info-btn').on('click',function(e){
        e.preventDefault();

        const $this = $(this);

        // grab all of the form values and send them to the AJAX handler function
        const userInfoObj = {};
        const requiredFieldsArray = [
          "userFirstName",
          "userLastName",
          "userEmail",
          "userPhoneNumber",
          "userBillingAddress1",
          "userBillingCity",
          "userBillingState",
          "userBillingPostcode",
          "userShippingAddress1",
          "userShippingCity",
          "userShippingState",
          "userShippingPostcode"
        ];
        let isValid = true;
        $('#user-info-form').find('[name^="user"]').each((i, e) => {
          const fieldName = $(e).attr('name');
          const fieldValue = $(e).val();

          if (requiredFieldsArray.includes(fieldName)) {
            // it's a required field
            if (typeof fieldValue == 'undefined' || fieldValue == null || fieldValue == '') {
              isValid = false;
              let radioToggle = null;
              if (fieldName.includes('Shipping')) {
                radioToggle = 'shipping';
              } else {
                radioToggle = 'billing';
              }
              $(`#${radioToggle}-address-toggle`).trigger('click');
              $(`[name="${fieldName}"]`).css({"border-color":"#ED4337"});
              return;
            } else {
              $(`[name="${fieldName}"]`).css({"border-color":"#e1e1e8"});
            }
          }
          userInfoObj[fieldName] = fieldValue;
        });

        if (isValid) {
          $this.html('<i class="far fa-spinner fa-pulse"></i>');
          const $promise = $.ajax({
            url: my_account.ajaxUrl,
            method: 'post',
            dataType: 'json',
            data: {'json': userInfoObj, 'security': my_account.nonce, 'action': 'updateUserAccountAndAddressInfo'}
          });

          $promise.done((response, textStatus, jqXhr) => {
            if (response.status == 'success') {
              $this.css({"background-color":"#cecece"});
              $this.html('<i class="icon-custom-checkmark"></i>');
              setTimeout(() => {
                $this.css({"background-color":"#ce3262"});
                $this.html('SAVE');
              },2000);

              // update the front of the card
              $('.my-account__account-details__user-details__name').text(`${response.data.userFirstName} ${response.data.userLastName}`);
              $('.my-account__account-details__user-details__email').text(response.data.userEmail);
              $('.my-account__account-details__user-details__phone').text(response.data.userPhoneNumber);
              // format the billing address
              let billingCompany = '';
              if (typeof response.data.userBillingCompany !== 'undefined' && response.data.userBillingCompany !== null && response.data.userBillingCompany !== '') {
                billingCompany = `${response.data.userBillingCompany}<br>`;
              }

              let billingAddress1 = '';
              if (typeof response.data.userBillingAddress1 !== 'undefined' && response.data.userBillingAddress1 !== null && response.data.userBillingAddress1 !== '') {
                billingAddress1 = `${response.data.userBillingAddress1}<br>`;
              }

              let billingAddress2 = '';
              if (typeof response.data.userBillingAddress2 !== 'undefined' && response.data.userBillingAddress2 !== null && response.data.userBillingAddress2 !== '') {
                billingAddress2 = `${response.data.userBillingAddress2}<br>`;
              }

              let postcodeSpacer = '';
              let cityStateZipLine = '';
              if (typeof response.data.userBillingCity !== 'undefined' && response.data.userBillingCity !== null && response.data.userBillingCity !== '') {
                if (typeof response.data.userBillingState !== 'undefined' && response.data.userBillingState !== null && response.data.userBillingState !== '') {
                  cityStateZipLine += `${response.data.userBillingCity}, ${response.data.userBillingState}`;
                  postcodeSpacer = " ";
                } else {
                  cityStateZipLine += userBillingCity;
                  postcodeSpacer = " ";
                }

              } else {
                if (typeof response.data.userBillingState !== 'undefined' && response.data.userBillingState !== null && response.data.userBillingState !== '') {
                  cityStateZipLine += response.data.userBillingState;
                  $postcodeSpacer = " ";
                }
              }

              if (typeof response.data.userBillingPostcode !== 'undefined' && response.data.userBillingPostcode !== null && response.data.userBillingPostcode !== '') {
                cityStateZipLine += postcodeSpacer+response.data.userBillingPostcode;
              }

              const fullBillingAddress = billingCompany+billingAddress1+billingAddress2+cityStateZipLine;
              $('#user-billing-address').html(fullBillingAddress);


              // format the shipping address
              let shippingCompany = '';
              if (typeof response.data.userShippingCompany !== 'undefined' && response.data.userShippingCompany !== null && response.data.userShippingCompany !== '') {
                shippingCompany = `${response.data.userShippingCompany}<br>`;
              }

              let shippingAddress1 = '';
              if (typeof response.data.userShippingAddress1 !== 'undefined' && response.data.userShippingAddress1 !== null && response.data.userShippingAddress1 !== '') {
                shippingAddress1 = `${response.data.userShippingAddress1}<br>`;
              }

              let shippingAddress2 = '';
              if (typeof response.data.userShippingAddress2 !== 'undefined' && response.data.userShippingAddress2 !== null && response.data.userShippingAddress2 !== '') {
                shippingAddress2 = `${response.data.userShippingAddress2}<br>`;
              }

              postcodeSpacer = '';
              cityStateZipLine = '';
              if (typeof response.data.userShippingCity !== 'undefined' && response.data.userShippingCity !== null && response.data.userShippingCity !== '') {
                if (typeof response.data.userShippingState !== 'undefined' && response.data.userShippingState !== null && response.data.userShippingState !== '') {
                  cityStateZipLine += `${response.data.userShippingCity}, ${response.data.userShippingState}`;
                  postcodeSpacer = " ";
                } else {
                  cityStateZipLine += userShippingCity;
                  postcodeSpacer = " ";
                }

              } else {
                if (typeof response.data.userShippingState !== 'undefined' && response.data.userShippingState !== null && response.data.userShippingState !== '') {
                  cityStateZipLine += response.data.userShippingState;
                  $postcodeSpacer = " ";
                }
              }

              if (typeof response.data.userShippingPostcode !== 'undefined' && response.data.userShippingPostcode !== null && response.data.userShippingPostcode !== '') {
                cityStateZipLine += postcodeSpacer+response.data.userShippingPostcode;
              }

              const fullShippingAddress = shippingCompany+shippingAddress1+shippingAddress2+cityStateZipLine;
              $('#user-shipping-address').html(fullShippingAddress);
            } else {
              console.log('Something happened and the status was not Success');
            }
          });

          $promise.fail((jqXhr, textStatus, errorThrown) => {
            console.log(jqXhr);
            console.log(textStatus);
            console.log(errorThrown);
            $this.html('SAVE');
          });
        }

      });
    }

    // handler for saving the pro info
    if ($('#save-pro-info-btn').length) {
      $('#save-pro-info-btn').on('click', function(e){
        e.preventDefault();
        
        const $this = $(this);
        const proCode = $('#your-pro-code').val();

        if (typeof proCode !== 'undefined' && proCode !== null && proCode !== '') {
          $('#your-pro-code').css({"border-color":"#e1e1e8"});
          const jsonObj = {'proCode': proCode};

          console.log("my_account: ", my_account);

          $this.html('<i class="far fa-spinner fa-pulse"></i>');
          const $promise = $.ajax({
            url: my_account.ajaxUrl,
            method: 'post',
            dataType: 'json',
            data: {'json': jsonObj, 'security': my_account.nonce, 'action': 'myAccountSaveProCode'}
          });

          $promise.done((response, textStatus, jqXhr) => {
            console.log(response);
            if (response.status == 'success') {
              $this.css({"background-color":"#cecece"});
              $this.html('<i class="icon-custom-checkmark"></i>');
              setTimeout(() => {
                $this.css({"background-color":"#ce3262"});
                $this.html('SAVE');
              },2000);

              if ($('#add-a-pro-btn').length) {
                $('#add-a-pro-btn').closest('.my-account__account-details__epionce-near-you-btn-container').remove();
              } else if ($('.my-account__account-details__pro-details').length) {
                $('.my-account__account-details__pro-details').remove();
              }

              if (typeof response.data.address_line_2 == 'undefined' || response.data.address_line_2 == null || response.data.address_line_2 == '' || response.data.address_line_2 == 'null') {
                var addressLine2 = '';
              } else {
                var addressLine2 = `${response.data.address_line_2}<br>`;
              }

              const html = `<div class="my-account__account-details__pro-details"><div class="my-account__account-details__pro-details__inner"><h3 class="my-account__account-details__pro-details__name">${response.data.business_name}</h3><p class="my-account__account-details__pro-details__phone">${response.data.phone_number}</p><address class="my-account__account-details__pro-details__address">${response.data.address}<br>${addressLine2}${response.data.city}, ${response.data.state} ${response.data.zipcode}</address><a class="my-account__account-details__pro-details__remove-professional" href="#" id="remove-professional-button" data-toggle="modal" data-target="#remove-professional-modal">Remove Professional <i class="icon-custom-trash-can"></i></a></div></div>`;
            $('.my-account__account-details__pro__card__front').append(html);
            } else if (response.status == 'fail') {
              $('#your-pro-code').val('');
              alert(response.data.proCode);
            

              $this.html('SAVE');
            } else {
              console.log('Something happened and the status was not Success or Fail');
            }
          });

          $promise.fail((jqXhr, textStatus, errorThrown) => {
            console.log(jqXhr);
            console.log(textStatus);
            console.log(errorThrown);
            $this.html('SAVE');
          });
        } else {
          $('#your-pro-code').css({"border-color":"#ED4337"});
        }
      });
    }

    // handler for the possible Connect to a Professional button
    // that appears if the user has no provider for some reason
    if ($('.my-account__account-details__pro__card__front').length) {
      $('.my-account__account-details__pro__card__front').on('click','#add-a-pro-btn',e => {
        e.preventDefault();
        $('.my-account__account-details__pro').toggleClass('flipped');
      })
    }

    // Matchheight.js on user detail cards
    $('.my-account__account-details__user-and-pro-info').find('div[class*="__card"]').matchHeight();
  },
  finalize() {
    // JavaScript to be fired on the My Account page, after the init JS
    // iterate through each of the recent orders details rows
    // so we can calculate the height and save it for the transition effect
    // $('.order-details').each((i, e) => {
    //   let calculatedHeight = 0;
    //   console.log(i, e);
    //   calculatedHeight = $(e).closest('.order-details-items').height();
    //   console.log('calculatedHeight: ', calculatedHeight);
    //   $(e).attr('data-active-height',calculatedHeight);
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/myAccount.js